// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router' // 导入路由配置
import { showVConsole, hideVConsole } from './vconsole'
import Toast from './plugins/toast' // 导入Toast插件
import Loading from './components/Loading.vue' // 导入Loading组件
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
// showVConsole()
hideVConsole()

// 配置忽略的自定义元素，避免Vue警告
// 微信小程序跳转组件
Vue.config.ignoredElements = [
  'wx-open-launch-weapp'
]

// 注册Toast插件
Vue.use(Toast)

// 全局注册Loading组件
Vue.component('Loading', Loading)

// Vue.use(ElementUI);

/**
 * Vue应用程序入口
 * 创建Vue实例并挂载到DOM
 */
new Vue({
  router, // 注入路由实例
  render: h => h(App),
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js